var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"viewBox":"0 0 24 24","role":"presentation","focusable":"false","xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}},[_c('path',{attrs:{"d":"M18 8H8v10H6V8a2 2 0 012-2h10v2m-4-6H4a2 2 0 00-2 2v10h2V4h10V2m8 10v8a2 2 0 01-2 2h-8a2 2 0 01-2-2v-8a2 2 0 012-2h8a2 2 0 012 2m-2 3h-3v-3h-2v3h-3v2h3v3h2v-3h3v-2z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }